import React, { useState, useEffect } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp, FaCheckCircle } from 'react-icons/fa';
import { postIletisim, getSiteBilgileri } from '../services/api';
import './Iletisim.css';

const Iletisim = () => {
  const [form, setForm] = useState({
    ad_soyad: '',
    email: '',
    telefon: '',
    konu: '',
    mesaj: '',
  });
  const [gonderildi, setGonderildi] = useState(false);
  const [hata, setHata] = useState('');
  const [ayar, setAyar] = useState(null);

  useEffect(() => {
    getSiteBilgileri()
      .then(res => setAyar(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    try {
      await postIletisim(form);
      setGonderildi(true);
      setForm({ ad_soyad: '', email: '', telefon: '', konu: '', mesaj: '' });
    } catch (err) {
      setHata('Mesaj gönderilemedi. Lütfen tekrar deneyin.');
    }
  };

  return (
    <div className="iletisim-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>İletişim</h1>
          <p>Bizimle iletişime geçin</p>
        </div>
      </section>

      <section className="iletisim-content">
        <div className="container">
          <div className="iletisim-grid">
            <div className="iletisim-info">
              <h2>İletişim Bilgileri</h2>
              <div className="info-item">
                <FaPhone className="info-icon" />
                <div>
                  <h4>Telefon</h4>
                  <a href={`tel:${ayar?.telefon?.replace(/\s/g, '') || '05320000000'}`}>{ayar?.telefon || '0532 000 00 00'}</a>
                </div>
              </div>
              <div className="info-item">
                <FaWhatsapp className="info-icon whatsapp" />
                <div>
                  <h4>WhatsApp</h4>
                  <a href={`https://wa.me/${ayar?.whatsapp || '905320000000'}`}>{ayar?.telefon || '0532 000 00 00'}</a>
                </div>
              </div>
              <div className="info-item">
                <FaEnvelope className="info-icon" />
                <div>
                  <h4>E-posta</h4>
                  <a href={`mailto:${ayar?.email || 'info@karpatotomotiv.com'}`}>{ayar?.email || 'info@karpatotomotiv.com'}</a>
                </div>
              </div>
              <div className="info-item">
                <FaMapMarkerAlt className="info-icon" />
                <div>
                  <h4>Adres</h4>
                  <p>{ayar?.adres || 'Organize Sanayi Bölgesi, İstanbul'}</p>
                </div>
              </div>
              <div className="info-item">
                <FaClock className="info-icon" />
                <div>
                  <h4>Çalışma Saatleri</h4>
                  <p>Pzt-Cum: {ayar?.hafta_ici_saatler || '08:00-18:00'}</p>
                  <p>Cumartesi: {ayar?.cumartesi_saatler || '09:00-15:00'}</p>
                  <p>Pazar: {ayar?.pazar_saatler || 'Kapalı'}</p>
                </div>
              </div>
            </div>

            <div className="iletisim-form-wrapper">
              <h2>Bize Yazın</h2>
              {gonderildi ? (
                <div className="success-message">
                  <FaCheckCircle />
                  <h3>Mesajınız Gönderildi!</h3>
                  <p>En kısa sürede size dönüş yapacağız.</p>
                  <button onClick={() => setGonderildi(false)} className="btn btn-primary">
                    Yeni Mesaj Gönder
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="iletisim-form">
                  {hata && <div className="error-message">{hata}</div>}
                  <div className="form-group">
                    <label>Ad Soyad *</label>
                    <input
                      type="text"
                      name="ad_soyad"
                      value={form.ad_soyad}
                      onChange={handleChange}
                      required
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Telefon *</label>
                      <input
                        type="tel"
                        name="telefon"
                        value={form.telefon}
                        onChange={handleChange}
                        required
                        placeholder="05XX XXX XX XX"
                      />
                    </div>
                    <div className="form-group">
                      <label>E-posta</label>
                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="ornek@email.com"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Konu *</label>
                    <input
                      type="text"
                      name="konu"
                      value={form.konu}
                      onChange={handleChange}
                      required
                      placeholder="Mesajınızın konusu"
                    />
                  </div>
                  <div className="form-group">
                    <label>Mesaj *</label>
                    <textarea
                      name="mesaj"
                      value={form.mesaj}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Mesajınızı buraya yazın..."
                    ></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary btn-full">
                    Mesaj Gönder
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Iletisim;
